export default __webpack_public_path__ + "static/media/done.bf5ee0cc.svg";